import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import axios from 'axios';
import Popup from '../../../components/Popup';
import ConfirmBankDelete from './ConfirmBankDelete';
import EditBank from './EditBank';
import AddBranch from './AddBranch';
import EditBranch from './EditBranch';
import ConfirmBranchDelete from './ConfirmBranchDelete'
import { useSetRecoilState, useRecoilValue } from 'recoil'
import { banksState } from '../recoil/atoms'
import { filteredBankState } from '../recoil/selectors'

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
});

const Branch = props => {
    const { branch, number } = props
    const [deleteBranchPopup, setDeleteBranchPopup] = useState(false)
    const [editBranchPopup, setEditBranchPopup] = useState(false)

    return (
        <TableRow>
            <Popup
                title="ویرایش شعبه"
                openPopup={editBranchPopup}
                setOpenPopup={setEditBranchPopup}
            >
                <EditBranch
                    id={branch.id}
                    name={branch.name}
                    setPopup={setEditBranchPopup}
                    setBranchesState={props.setBranchesState}
                    branchesState={props.branchesState}
                />
            </Popup>
            <Popup
                title={"حذف شعبه " + branch.name}
                openPopup={deleteBranchPopup}
                setOpenPopup={setDeleteBranchPopup}
            >
                <ConfirmBranchDelete
                    id={branch.id}
                    setPopup={setDeleteBranchPopup}
                    setBranchesState={props.setBranchesState}
                    branchesState={props.branchesState}
                />
            </Popup>
            <TableCell component="p">
                {number}
            </TableCell>
            <TableCell component="th">
                {branch.name}
            </TableCell>
            <TableCell align="right">
                <IconButton onClick={() => setEditBranchPopup(true)}>
                    <EditIcon />
                </IconButton>
            </TableCell>
            <TableCell align="right">
                <IconButton onClick={() => setDeleteBranchPopup(true)}>
                    <DeleteIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    )
}

const Bank = props => {
    const { bank, number } = props;
    const [open, setOpen] = useState(false);
    const classes = useRowStyles();
    const [deleteBankPopup, setDeleteBankPopup] = useState(false)
    const [editBankPopup, setEditBankPopup] = useState(false)
    const [addBranchPopup, setAddBranchPopup] = useState(false)
    const [branchesState, setBranchesState] = useState([])
    const deleteBankMessage = "آیا از حذف بانک " + bank.name + " مطمئن هستید؟"
    const addBranchMessage = "افزودن شعبه به بانک " + bank.name

    // Get branches of a bank
    const getBranchesData = async () => {
        const data = await axios.get('accounts/branch/?bank_id=' + bank.id).then(result => result.data)
        setBranchesState(data)
    }
    useEffect(() => {
        getBranchesData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <>
            <Popup
                title={deleteBankMessage}
                openPopup={deleteBankPopup}
                setOpenPopup={setDeleteBankPopup}
            >
                <ConfirmBankDelete id={bank.id} setPopup={setDeleteBankPopup} />
            </Popup>
            <Popup
                title='ویرایش'
                openPopup={editBankPopup}
                setOpenPopup={setEditBankPopup}
            >
                <EditBank id={bank.id} name={bank.name} setPopup={setEditBankPopup} />
            </Popup>
            <Popup
                title={addBranchMessage}
                openPopup={addBranchPopup}
                setOpenPopup={setAddBranchPopup}
            >
                <AddBranch bankID={bank.id} setPopup={setAddBranchPopup} setBranchesState={setBranchesState} branchesState={branchesState} />
            </Popup>
            <TableRow className={classes.root}>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                    {number}
                </TableCell>
                <TableCell component="th" scope="row">
                    {bank.name}
                </TableCell>
                <TableCell align="right">
                    <IconButton onClick={() => setAddBranchPopup(true)} size="small">
                        <AddIcon />
                    </IconButton>
                </TableCell>
                <TableCell align="right">
                    <IconButton onClick={() => setEditBankPopup(true)} size="small">
                        <EditIcon />
                    </IconButton>
                </TableCell>
                <TableCell align="right">
                    <IconButton onClick={() => setDeleteBankPopup(true)} size="small">
                        <DeleteIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" gutterBottom component="div">
                                شعب بانک {bank.name}
                            </Typography>
                            <Table size="small" aria-label="branches">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ردیف</TableCell>
                                        <TableCell>نام</TableCell>
                                        <TableCell align="right">ویرایش</TableCell>
                                        <TableCell align="right">حذف</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {branchesState.map((branch, key) => (
                                        <Branch
                                            key={key}
                                            number={key + 1}
                                            branch={branch}
                                            branchesState={branchesState}
                                            setBranchesState={setBranchesState}
                                        />
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}


const BanksTable = () => {
    const filteredBanks = useRecoilValue(filteredBankState)
    const setBanks = useSetRecoilState(banksState)
    // Get banks
    const getBankData = async () => {
        const data = await axios.get('accounts/bank/').then(result => result.data)
        setBanks(data)
    }
    useEffect(() => {
        getBankData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <TableContainer component={Paper}>
            <Table aria-label="banks">
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>ردیف</TableCell>
                        <TableCell>نام بانک</TableCell>
                        <TableCell align="right">
                            افزودن شعبه
                        </TableCell>
                        <TableCell align="right">
                            ویرایش
                        </TableCell>
                        <TableCell align="right">
                            حذف
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {filteredBanks.map((bank, key) => (
                        <Bank key={key} number={key + 1} bank={bank} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default BanksTable